


























































































import SubmitBtn from "@/components/Common/SubmitBtn.vue";
import InsuranceCommissionList from "../list/InsuranceCommissionList.vue";
import OfferItemCommissionList from "../list/OfferItemCommissionList.vue";
import ServiceFeeCommissionList from "../list/ServiceFeeCommissionList.vue";
import AccommodationCommissionList from "../list/AccommodationCommissionList.vue";
import { Component, Vue, Prop, ModelSync, Watch } from "vue-property-decorator";

@Component({
  name: "unsettledPayBackDialog",
  components: {
    SubmitBtn,
    InsuranceCommissionList,
    OfferItemCommissionList,
    ServiceFeeCommissionList,
    AccommodationCommissionList,
  },
})
export default class extends Vue {
  @ModelSync("dialogPayBackVisible", "changeVisible", { type: Boolean })
  public value!: boolean;

  @Prop() public readonly data!: any;

  public remark: string = "";
  public activeTab: string = "offerItem";
  // public submitSettlementDateTime: string = "";
  // public dialogTableVisible: boolean = false;
  // public dialogConfirmVisible: boolean = false;
  // public dialogSubmitSettledVisible = false; // 提交结算dialog
  // public isDifferentialSubmit = false; // 是否是差异提交

  public allTableSelects: any = {
    offerItem: [],
    insurance: [],
    accommodation: [],
    serviceFee: [],
  };
  // 差异提交第一步（弹出核对账单）
  public handleDifferentialSubmit() {
    const selecteds = this.allTableSelects;
    if (!selecteds.offerItem.length) {
      this.$message.error(this.$t('message.differentialSubmissionConfirm2') as string);
      return;
    }
    this.$emit('differential-submit', selecteds);
    this.handleClose();
    // this.dialogTableVisible = true;
    // this.isDifferentialSubmit = true;
  }
  // 差异提交第二步（差异提交完的后续操作）
  // public differentialSubmit(dateTime: string) {
  //   this.isSubmitted = true;
  //   this.handleClose();
  //   this.$emit('set-time', dateTime);
  // }
  // 结算提交
  public handleSubmitSettlement() {
    const selecteds = this.allTableSelects;
    const data = this.data;
    if (!selecteds.offerItem.length || selecteds.offerItem.length !== data.offerItem.length) {
      this.$message.error(this.$t('message.pleaseSelectAllUnsettledPayBackStatement') as string);
      return;
    }
    this.$emit('settlement-submit', selecteds);
    this.handleClose();
    // this.dialogTableVisible = true;
    // this.isDifferentialSubmit = false;
  }
  // 确认结算
  // public settlementSubmit(data: any) {
  //   this.dialogSubmitSettledVisible = true;
  //   this.allTableSelects = Object.assign({}, data);
  //   this.handleClose();
  // }

  public handleListSelect(type: string, row: any) {
    switch (type) {
      case "offerItem":
        this.allTableSelects.offerItem = row;
        break;
      // 暂时只需要留学申请部分
      // case "insurance":
      //   this.allTableSelects.insurance = row;
      //   break;
      // case "accommodation":
      //   this.allTableSelects.accommodation = row;
      //   break;
      // case "serviceFee":
      //   this.allTableSelects.serviceFee = row;
      //   break;
    }
  }

  public handleTabClick($event: any) {
    const dataset = $event.target.dataset;
    if (dataset.tab) {
      this.activeTab = dataset.tab;
    }
  }

  public handleClose() {
    this.$emit("changeVisible", false);
  }
}
